import helperActions from './helperActions.js';

export default () => ({
    ...helperActions(),

    async selectTile(tileIndex, shiftPressed) {
        const tile = this.tilesState[`${tileIndex}`];
        if (!tile) return;

        const eventId = tile.event_id;
        const tileId = tile.id;

        if (!tile.tags || tile.tags.length === 0) {
            tile.tags = [0];
        }

        this.selectedItems[eventId] ??= this.getTagsInitialState();

        for (const tagId of tile.tags) {
            this.selectedItems[eventId].tags[Number(tagId)] ??= {
                allSelected: false,
            };
        }

        if (shiftPressed && this.lastSelectedTileIndex !== undefined) {
            await this.handleShiftSelect(tileIndex, tile, eventId);

            this.shiftWasPressed = true;

            return;
        }

        const isSelected = this.isTileSelected(tile, eventId);

        const hasTagWithAllSelected = tile.tags.some(
            (tagId) => this.selectedItems[eventId].tags[Number(tagId)]?.allSelected,
        );

        if (!isSelected) {
            if (hasTagWithAllSelected) {
                const unselectedIndex =
                    this.selectedItems[eventId].manuallyUnselected.indexOf(tileId);

                if (unselectedIndex !== -1) {
                    this.selectedItems[eventId].manuallyUnselected.splice(unselectedIndex, 1);

                    for (const tagId of tile.tags) {
                        if (this.selectedTags.map(Number).includes(Number(tagId))) {
                            const unselectedTagIndex =
                                this.selectedItems[eventId].tags[tagId].manuallyUnselected?.indexOf(
                                    tileId,
                                );

                            if (unselectedTagIndex !== -1) {
                                this.selectedItems[eventId].tags[tagId].manuallyUnselected.splice(
                                    unselectedTagIndex,
                                    1,
                                );
                            }
                        } else {
                            const unselectedTagIndex =
                                this.selectedItems[eventId].tags[tagId].manuallyUnselected?.indexOf(
                                    tileId,
                                );

                            if (unselectedTagIndex !== -1) {
                                this.selectedItems[eventId].tags[tagId].manuallyUnselected.splice(
                                    unselectedTagIndex,
                                    1,
                                );
                            }
                        }
                    }
                }

                this.lastSelectedTileIndex = tileIndex;

                return;
            }

            !this.selectedItems[eventId].manuallySelected.includes(tileId) &&
                this.selectedItems[eventId].manuallySelected.push(tileId);

            this.lastSelectedTileIndex = tileIndex;

            return;
        } else if (isSelected && this.shiftWasPressed) {
            !this.unselectedAfterShiftSelect.includes(tileId) &&
                this.unselectedAfterShiftSelect.push(tileId);
        }

        if (hasTagWithAllSelected) {
            if (!this.selectedItems[eventId].manuallyUnselected.includes(tileId)) {
                this.selectedItems[eventId].manuallyUnselected.push(tileId);

                for (const tagId of tile.tags) {
                    if (this.selectedTags.map(Number).includes(Number(tagId))) {
                         const currentManuallyUnselected = new Set(
                            this.selectedItems[eventId].tags[tagId].manuallyUnselected ?? [],
                        );

                        if (!currentManuallyUnselected.has(tileId)) {
                            this.selectedItems[eventId].tags[tagId].manuallyUnselected = [
                                ...currentManuallyUnselected,
                                tileId,
                            ];
                        }
                    } else {
                        const unselectedTagIndex =
                            this.selectedItems[eventId].tags[tagId].manuallyUnselected?.indexOf(
                                tileId,
                            );

                        if (unselectedTagIndex !== -1) {
                            this.selectedItems[eventId].tags[tagId].manuallyUnselected.splice(
                                unselectedTagIndex,
                                1,
                            );
                        }
                    }
                }
            }

            this.lastSelectedTileIndex = tileIndex;

            return;
        }

        const selectedIndex = this.selectedItems[eventId].manuallySelected.indexOf(tileId);

        selectedIndex !== -1 &&
            this.selectedItems[eventId].manuallySelected.splice(selectedIndex, 1);

        this.lastSelectedTileIndex = tileIndex;
    },

    async handleShiftSelect(tileIndex) {
        const start = Math.min(this.lastSelectedTileIndex, tileIndex);
        const end = Math.max(this.lastSelectedTileIndex, tileIndex);

        for (let i = start; i <= end; i++) {
            const tile = this.tilesState[`${i}`];
            if (!tile) continue;

            const eventId = tile.event_id;
            const tileId = tile.id;
            const tileTags = tile.tags?.length ? tile.tags.map(Number) : [0];

            if (eventId === undefined && tileId === undefined) continue;

            this.selectedItems[eventId] ??= {
                manuallySelected: [],
                manuallyUnselected: [],
                tags: {},
            };

            for (const tagId of tileTags) {
                this.selectedItems[eventId].tags[tagId] ??= {
                    allSelected: false,
                };

                this.selectedItems[eventId].tags[tagId].allSelected = false;
            }

            const unselectedIndex = this.selectedItems[eventId].manuallyUnselected.indexOf(tileId);

            if (unselectedIndex !== -1) {
                this.selectedItems[eventId].manuallyUnselected.splice(unselectedIndex, 1);

                for (const tagId of tileTags) {
                    if (this.selectedTags.map(Number).includes(Number(tagId))) {
                        const unselectedTagIndex =
                            this.selectedItems[eventId].tags[tagId].manuallyUnselected?.indexOf(tileId);

                        if (unselectedTagIndex !== -1) {
                            this.selectedItems[eventId].tags[tagId].manuallyUnselected.splice(
                                unselectedTagIndex,
                                1,
                            );
                        }
                    }
                }
            }

            if (eventId !== undefined && tileId !== undefined && !this.selectedItems[eventId].manuallySelected.includes(tileId)) {
                this.selectedItems[eventId].manuallySelected.push(tileId);
            }
        }

        const startTile = this.tilesState[start];
        const endTile = this.tilesState[end];

        if (!startTile || !endTile) return;

        const startSegmentId = parseInt(startTile.segmentId);
        const endSegmentId = parseInt(endTile.segmentId);
        const startSectionId = parseInt(startTile.sectionId);
        const endSectionId = parseInt(endTile.sectionId);

        if (startSegmentId !== endSegmentId) {
           this.fetchingImages = true;
           this.$dispatch('update-fetching-images', this.fetchingImages);

            await this.selectTilesAcrossSegments(start, end, startSectionId, endSectionId);

            this.fetchingImages = false;
            this.$dispatch('update-fetching-images', this.fetchingImages);
        }

        this.lastSelectedTileIndex = tileIndex;
    },

    async selectTilesAcrossSegments(firstIndex, lastIndex, startSectionId, endSectionId) {
        const imageIds = await this.getImageIdsFromSegmentsAndSections(
            startSectionId,
            endSectionId,
            firstIndex,
            lastIndex
        );

        this.selectionIdRanges = this.mergeRanges(this.groupRangeIds(imageIds));
    },

    getImageIdsFromSegmentsAndSections(startSectionId, endSectionId, startIndex, endIndex) {
        const { offset, limit } = this.calculateSelectionParams(startSectionId, endSectionId, startIndex, endIndex);

        const params = {
            ...this.params,
            offset,
            limit,
        };

        try {
            return fetch(`/photo-view/${this.route}/image-ids?` + new URLSearchParams(params)).then(
                (res) => {
                    return res.json();
                },
            );
        } catch (error) {
            console.error('There was a problem while fetching image IDs:', error);
        }
    },

    selectAll() {
        this.shiftWasPressed = false;
        if (!this.eventId || !this.totalTiles) return;

        const eventId = this.eventId;
        const initialState = this.getTagsInitialState();
        const currentSelected = this.selectedItems[eventId] ?? initialState;
        currentSelected.tags ??= initialState.tags;

        const manuallySelectedLength = new Set(currentSelected.manuallySelected ?? []).size;
        const manuallyUnselectedLength = new Set(currentSelected.manuallyUnselected ?? []).size;
        const allTagsSelected = Object.values(currentSelected.tags).every((tag) => tag.allSelected);

        if (allTagsSelected && manuallySelectedLength === 0 && manuallyUnselectedLength === 0)
            return;

        const relevantTags = this.getRelevantTags();
        const hasOtherSelections = this.hasSelectionsInOtherEvents(eventId);

        if (this.selectedTags.length && this.selectedTags.length < 3) {
            this.handleSelectionWithTags(currentSelected, hasOtherSelections);

            if (this.selectedTags.length === 1 && this.selectedTags[0] != 0) {
                const notCurrentTag = Object.keys(currentSelected.tags).find(
                    (tagId) => tagId != this.selectedTags[0] && tagId != 0,
                );

                if (currentSelected.tags[notCurrentTag]?.allSelected) {
                    currentSelected.manuallyUnselected = [];

                    this.clearManuallyUnselectedFromTags(Object.keys(currentSelected.tags).filter(
                        (tagId) => tagId != 0,
                    ));
                } else {
                    currentSelected.manuallyUnselected = [];
                }
            } else {
                currentSelected.manuallyUnselected = [];
            }
        } else {
            currentSelected.manuallySelected = [];
            currentSelected.manuallyUnselected = [];
        }

        relevantTags.forEach((tag) => {
            const allSelected = !this.selectedTags.length
                ? true
                : this.handleAllSelected(
                      tag.id,
                      currentSelected.tags[tag.id]?.allSelected ?? false,
                  );

            currentSelected.tags[tag.id] = {
                allSelected,
                manuallyUnselected: currentSelected.tags[tag.id]?.manuallyUnselected ?? [],
            };
        });

        this.selectedItems[eventId] = currentSelected;
    },

    deselectAll() {
        this.shiftWasPressed = false;
        if (!this.eventId) return;

        const eventId = this.eventId;
        const currentSelected = (this.selectedItems[eventId] ??= this.getTagsInitialState());
        const allTagsDeselected = Object.values(currentSelected.tags).every((tag) => !tag.allSelected);
        const currentSelectedLength = new Set(currentSelected.manuallySelected ?? []).size;
        const manuallyUnselectedLength = new Set(currentSelected.manuallyUnselected ?? []).size;

        const relevantSelectedTags = Object.values(this.availableTags).filter((tag) => {
            return this.selectedTags.map(Number).includes(tag.id);
        });

        let relevantTags = this.selectedTags.length
            ? relevantSelectedTags
            : Object.values(this.availableTags);

        if (allTagsDeselected && !currentSelectedLength && !manuallyUnselectedLength) {
            return;
        }

        if (this.selectedTags.length && this.selectedTags.length < 3) {
            this.handleDeselectionWithTags(currentSelected, relevantTags);

            this.clearManuallyUnselectedFromTags(
                relevantTags.map((tag) => tag.id),
            );
        } else {
            currentSelected.manuallySelected = [];
            currentSelected.manuallyUnselected = [];
        }

        const handleAllDeselected = (tagId, currentValue) => {
            return this.selectedTags.map(Number).includes(Number(tagId)) ? false : currentValue;
        };

        if (this.selectedTags.length && !this.selectedTags.map(Number).includes(0)) {
            relevantTags = relevantTags.filter((tag) => tag.id != 0);
        }

        relevantTags.forEach((tag) => {
            const allSelected = !this.selectedTags.length
                ? false
                : handleAllDeselected(tag.id, currentSelected.tags[tag.id]?.allSelected ?? false);

            currentSelected.tags[tag.id] = {
                allSelected,
                manuallyUnselected: currentSelected.tags[tag.id]?.manuallyUnselected ?? [],
            };
        });

        this.selectedItems[eventId] = currentSelected;

        this.lastSelectedTileIndex = undefined;
    },

    isSelected(tileIndex) {
        const tile = this.tilesState[tileIndex];
        if (!tile) return false;

        const eventId = tile.event_id;
        const selectedItems = this.selectedItems[eventId];

        if (!selectedItems) return false;

        const tileId = tile.id;
        const tileTags = tile.tags?.length ? tile.tags.map(Number) : [0];

        const hasTagWithAllSelected = tileTags.some(
            (tagId) => selectedItems.tags[tagId]?.allSelected,
        );

        if (hasTagWithAllSelected) {
            if (selectedItems.manuallyUnselected.includes(tileId)) {
                return false;
            }

            const notCurrentTag = Object.keys(selectedItems.tags).find(
                (tagId) => tagId != 0 && !this.selectedTags.map(Number).includes(Number(tagId)),
            );

            if (selectedItems.tags[notCurrentTag]?.manuallyUnselected?.includes(tileId)) {
                return false;
            }

            return true;
        }

        return selectedItems.manuallySelected.includes(tileId);
    }
});
